import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { Subscription } from 'rxjs'
import { PaginationModel } from '../../../../../models/pagination.model'
import { HttpResponseHandlerService } from '../../../../../services/http-response-handler.service'
import { AnalysisRcaFilterModel } from '../../../../../filters/analysis-rca-filter.modal'
import { IFinalElementAnalyzerResource } from '../../../../../resources/final-element-analyzer.resource'
import { HttpErrorResponse } from '@angular/common/http'
import { HelperService } from '../../../../../services/helper.service'
import { IAnalysisHistoryService } from '../i-analysis-history.service'

@Component({
    selector: 'app-analysis-history',
    templateUrl: './analysis-history.component.html',
    standalone: false
})
export class AnalysisHistoryComponent implements OnInit, OnDestroy {
  @Input() type: 'F' | 'D'
  @Input() serviceInstance: IAnalysisHistoryService
  @Input() tagName: string
  @Input() rcaNo: string

  public maxBodyTableHeight = '640px'

  private _rcaNoIsActiveSubscription: Subscription
  private _pagination: PaginationModel = new PaginationModel()
  private _isLoading: boolean = false
  private _reportItems: any[] = []
  private _collectionSize: number = 0

  public get page(): number {
    return this._pagination.no
  }

  public get pageSize(): number {
    return this._pagination.size
  }

  public get collectionSize(): number {
    return this._collectionSize
  }

  public get isLoading(): boolean {
    return this._isLoading
  }

  public get reportItems(): any[] {
    return this._reportItems
  }

  constructor(private responseHandlerService: HttpResponseHandlerService) {}

  public getRCALabel(): string {
    if (this.type === 'F') {
      return 'RCA Fault No'
    }
    if (this.type === 'D') {
      return 'RCA Demand No'
    }
    return 'RCA No'
  }

  private getReportData(): void {
    this._isLoading = true
    this._reportItems = []
    const filter = new AnalysisRcaFilterModel({ tagName: this.tagName })
    this.serviceInstance.getRCAReportData(this._pagination, filter, false).subscribe(
      (resource: IFinalElementAnalyzerResource) => {
        this._reportItems = resource.data.items
        this._collectionSize = resource.data.count
        this._isLoading = false
      },
      (error: HttpErrorResponse) => {
        this.responseHandlerService.notifyError(error)
        this._isLoading = false
      },
    )
  }

  public onPageChanged(event) {
    this._pagination.no = event
    HelperService.scrollToTopNzTable()
    this.getReportData()
  }

  public onPageSizeChanged(event: number): void {
    this._pagination.no = 1
    this._pagination.size = event
    this.getReportData()
  }

  private onRcaNoIsActiveChangeEvent(): void {
    this._rcaNoIsActiveSubscription = this.serviceInstance.rcaNoIsActiveSubject.subscribe(
      (isActive: boolean) => {
        this.getReportData()
      },
    )
  }

  ngOnInit(): void {
    this.getReportData()
    this.onRcaNoIsActiveChangeEvent()
  }

  ngOnDestroy(): void {
    if (this._rcaNoIsActiveSubscription) {
      this._rcaNoIsActiveSubscription.unsubscribe()
    }
  }
}
